import { openOptionsMenu } from '../globalState'
import { disconnect } from '../flyingSquidUtils'
import Button from './Button'
import styles from './PauseScreen.module.css'

export default ({ onReturnPress, lockConnect }: { onReturnPress: () => void, lockConnect: boolean }) => {
  return (
    <div className={styles.pause_container}>
      <Button className="button" onClick={onReturnPress}>Back to Replay</Button>
      <Button className="button" onClick={() => openOptionsMenu('replay')}>Options...</Button>
      {!lockConnect && (
        <Button className="button" onClick={disconnect}>
          Disconnect & Reset
        </Button>
      )}
    </div>
  )
}
